import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AppLayout } from './components/layout';
import { ProtectedRoute } from './features/auth';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import StudentDashboard from './pages/StudentDashboard';
import ClassDetails from './pages/ClassDetails';
import ClassroomInsights from './pages/ClassroomInsights';
import FeedbackManagement from './pages/FeedbackManagement';
import SetupWizard from './pages/SetupWizard';
import FeedbackReports from './pages/FeedbackReports';
import StudentDetails from './pages/StudentDetails';
import Students from './pages/Students';
import SurveyResults from './pages/SurveyResults';
import Survey from './pages/Survey';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route element={<AppLayout />}>
          <Route path="/survey" element={<Survey />} />
          <Route 
            path="/dashboard" 
            element={
              <ProtectedRoute userType="professor">
                <Dashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/student-dashboard" 
            element={
              <ProtectedRoute userType="student">
                <StudentDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/student-dashboard/:classId" 
            element={
              <ProtectedRoute userType="student">
                <StudentDashboard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId" 
            element={
              <ProtectedRoute userType="professor">
                <ClassDetails />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/insights" 
            element={
              <ProtectedRoute userType="professor">
                <ClassroomInsights />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/feedback" 
            element={
              <ProtectedRoute userType="professor">
                <FeedbackManagement />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/students" 
            element={
              <ProtectedRoute userType="professor">
                <Students />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/feedback/setup" 
            element={
              <ProtectedRoute userType="professor">
                <SetupWizard />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/feedback/reports" 
            element={
              <ProtectedRoute userType="professor">
                <FeedbackReports />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/student/:studentId" 
            element={
              <ProtectedRoute userType="professor">
                <StudentDetails />
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/dashboard/class/:classId/student/:studentId/survey" 
            element={
              <ProtectedRoute userType="professor">
                <SurveyResults />
              </ProtectedRoute>
            } 
          />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;